import { useState } from "react"
import { useTranslation } from "react-i18next";

declare global {
    interface Window {
        //extend window to accept NDEFReader
        NDEFReader: any;
    }
}

export function NFCLogin({ callback }: { callback: Function }) {
    const { i18n } = useTranslation();

    // @ts-ignore
    const t = (txt: string) => i18n.t(txt);

    const [feedback, setFeedback] = useState(t('login.instructions.card_login'));
    // var haveNFC = false;//FIXME we fake that we have an NFC scanner available
    let abortController: AbortController;

    // function fakeScan() {
    //     return callback('1234567890');
    // }

    function scanTag() {
        setFeedback(t('scanning'));
        return new Promise((resolve, reject) => {
            try {
                const reader = new window.NDEFReader();
                abortController = new AbortController();
                reader.scan({ signal: abortController.signal })
                    .then(() => {
                        setFeedback(t('reader started'));
                        reader.onreadingerror = () => {
                            setFeedback(t('nfc_card_error'));
                            abortController.abort();
                        };
                        reader.onreading = (event: any) => {
                            setFeedback(t('nfc_card_read'));
                            abortController.abort();
                            if (event.serialNumber) {
                                setFeedback(`${t('nfc_serial')}: ${event.serialNumber}`);
                                callback(event.serialNumber);
                            }
                        };
                    }).catch((error: any) => {
                        setFeedback(`${t('nfc_start_error')}: ${error}.`);
                    });
            }
            catch (e) {
                console.log('error starting NFC reader:', e);
                reject(e);
            }
        });
    };

    if ('NDEFReader' in window) {
        //TODO add some kind of selector that enables (OR DISABLES) scanning from the backend
        //i.e. if a tenant does not use this, we do not want the app to start scanning anything it can get its hands on
        //NOTE for now: default ENABLED
        // haveNFC = true;
        return (<>
            <p id="feedback">{feedback}</p>
            <div className="col-md-6">
                <button id="scan" className="btn btn-primary" onClick={() => scanTag()}>{t('login.instructions.scan_card')}</button>
            </div>
        </>)
    }
    return (
        <>
            <p>{t('login.errors.no_nfc_reader')}</p>
            {/* <div className="col-md-6">
                <button id="scan" className="btn btn-primary" onClick={() => fakeScan()}>{t('login.instructions.scan_card')+'-fake'}</button>
            </div> */}
        </>
    )
}